export const handleErrors = async response => {
  if (!response.ok) {
    throw Error('Network response was not ok')
  }

  return response.json()
}
